// Choices index
$(document).ready(function () {
    // On page load
    $('.deletechoice-btn').on('click', function () {
        var id = $(this).attr('data-id');
        var choicename = $(this).attr('data-choicename');
        var choicetext = $(this).attr('data-choicetext');
        var choiceoptions = $(this).attr('data-choiceoptions');
        $('h4 span').empty().append(choicename);
        $('p.choicetext').empty().append(choicetext);
        $('p.optionstext').empty().append(choiceoptions);
        $('input[type="hidden"][name="id"]').val(id);
        $('#deletechoicemodal').modal('show');
    });
});
